import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import './content.scss';

@inject('appStore', 'routerStore')
@observer
export class ContentComponent extends Component {

    get404() {
        return <section className='content content--error content--error404'>
            <div>
                <h1 className='content-title'>
                    Page not found
                </h1>
                <div className='content-content'>
                    <p>
                        Sorry, this page was not found
                    </p>
                </div>
            </div>
        </section>;
    }

    get500() {
        return <section className='content content--error content--error404'>
            <div>
                <h1 className='content-title'>
                    Server Error
                </h1>
                <div className='content-content'>
                    <p>
                        Sorry, there was a problem handling your request. Please try
                        again later.
                    </p>
                </div>
            </div>
        </section>;
    }

    render() {
        const { routerStore } = this.props,
            is500 = routerStore.location.pathname === '/500';

        return <div>
            {is500 && <div>
                {this.get500()}
            </div>}
            {!is500 && <div>
                {this.get404()}
            </div>}
        </div>;
    }

}



// WEBPACK FOOTER //
// ./src/_content/content.component.js